export const MENU_BUTTON_MODE = {
  edition: 'edition',
  selection: 'selection',
} as const;

export type MenuButtonMode = typeof MENU_BUTTON_MODE[keyof typeof MENU_BUTTON_MODE];
